<template>
  <v-card :dark="darkmode">
    <v-card-title primary-title class="greyk lighten-4l">
      <h4 class="headline mb-0">{{ $t('settings') }}</h4>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tab v-for="item in tabitems" :key="item">{{ item }}</v-tab>
      </v-tabs>
      <v-divider></v-divider>

      <v-tabs-items v-model="tab">
        <!-- school settings tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <!-- school settings inside tabs-->
              <vertical-tabs
                :items="schooltabs"
                :verticalText="false"
                color="#f5f5f5"
                slider-color="red"
                v-on:tabchange="setTab2Selected($event)"
              >
                <template v-slot:titems>
                  <v-tabs-items v-model="tab2">
                     <v-tab-item>
                       <school-info></school-info>
                    </v-tab-item>
                    <v-tab-item>
                      <academic-years></academic-years>
                    </v-tab-item>
                    <v-tab-item>
                      <terms></terms>
                    </v-tab-item>
                    <!-- <v-tab-item>
                        <class-sections></class-sections>
                    </v-tab-item> -->

                    <v-tab-item>
                        <subjects/>
                    </v-tab-item>
                     <v-tab-item>
                       <admins></admins>
                    </v-tab-item>
                  </v-tabs-items>
                </template>
              </vertical-tabs>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- class settings tab -->
        <!-- <v-tab-item>
          <v-card flat>
            <v-card-text>
              <!-- class settings inside tabs --

              <vertical-tabs
                :items="classtabs"
                :verticalText="false"
                color="#f5f5f5"
                slider-color="red"
                v-on:tabchange="setTab3Selected($event)"
              >
               <template v-slot:titems>
                  <v-tabs-items v-model="tab3">
                    <v-tab-item>
                       <class-gen></class-gen>


                    </v-tab-item>
                    <v-tab-item>
                        <class-sections></class-sections>
                    </v-tab-item>
                  </v-tabs-items>
                </template>
              </vertical-tabs>
            </v-card-text>
          </v-card>
        </v-tab-item> -->

        <!-- Fees settings tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <!-- fees settings inside tabs-->
              <vertical-tabs
                :items="feestabs"
                :verticalText="false"
                color="#f5f5f5"
                slider-color="red"
                v-on:tabchange="setTab4Selected($event)"
              >
               <template v-slot:titems>
                  <v-tabs-items v-model="tab4">
                    <v-tab-item>

                      <fees-structure></fees-structure>
                    </v-tab-item>
                    <v-tab-item>
                      <additional-charges></additional-charges>
                    </v-tab-item>

                     <v-tab-item>
                      <fees-discount></fees-discount>
                    </v-tab-item>

                     <v-tab-item>
                      <fees-alert></fees-alert>
                    </v-tab-item>

                     <v-tab-item>
                      <ledgeraccs></ledgeraccs>
                    </v-tab-item>


                  </v-tabs-items>
                </template>
              </vertical-tabs>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- sms settings tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <sms-settings>

              </sms-settings>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>


<script>
import VerticalTabs from "../../../components/VerticalTabs";
import ClassGen from "../../../components/settings/classGen";
import ClassSections from "../../../components/settings/classSections";
import AccYears from "../../../components/settings/schoolAcademicYears";
import terms from "../../../components/settings/schoolTerms";
import fstruct from "../../../components/settings/feesStructure";
import fdiscs from "../../../components/settings/feesDiscounts";
import additionalCharges from "../../../components/settings/feesAdditionalCharges";
import feesAlert from "../../../components/settings/feesAlert"
import ledgeraccs from "../../../components/settings/ledgeraccs"
import sms from "../../../components/settings/sms";
import schoolInfo from "../../../components/settings/schoolInfo";
import subjects from "../../../components/settings/subject";
import adminAccounts from "../../../components/settings/adminAccounts";
import { mapGetters } from "vuex";


export default {
  name: "settings-view",
  components: {
    "vertical-tabs": VerticalTabs,
    "class-gen":ClassGen,
    "class-sections":ClassSections,
    "academic-years": AccYears,
    "terms":terms,
    "fees-structure":fstruct,
    "fees-discount":fdiscs,
    "additional-charges":additionalCharges,
   // "sms-settings":sms,
    "school-info":schoolInfo,
    "subjects":subjects,
    "admins":adminAccounts,
    "fees-alert":feesAlert,
    "ledgeraccs":ledgeraccs,
    "sms-settings":sms,
  },
  metaInfo() {
    return { title: this.$t("settings") };
  },
  computed: {
    ...mapGetters({
      darkmode: "settings/DARKMODE"
    })
  },
  methods: {
    setTab2Selected(val) {

      this.tab2 = val;
    },
    setTab3Selected(val) {

      this.tab3 = val;
    },
    setTab4Selected(val) {

      this.tab4 = val;
    }
  },
  data() {
    return {
      verticalText: false,
      containerStyle: "",
      searcht: "",
      searcho: "",
      tab: null,
      tab2: null,
      tab3: null,
      tab4: null,
      tabitems: [
        "General Settings", //was previously school settings
        // "Class Settings",
        "Financial Settings",
        "SMS Settings"
      ],
      schooltabs: ["School Info","Academic Years", "Academic Terms","Subjects","Admin. Accounts"],
      classtabs: ["General", "Class Sections"],
      feestabs: ["Fees Structures", "Additional Charges","Fees Discounts","Fee payment Alert","Ledger Accounts"],
    };
  }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/pages/shared/settings/settings.vue